<template>
    <div class="flex lg:flex-row md:flex-row flex-col gap-8 p-4">
        <!-- Left content -->
        <div class="flex-1 text-2xl">
            <h1 class="text-4xl">{{ $t("patients.prescription.title") }}</h1>
            <div
                v-html="`<p>${$t('patients.prescription.subtitle')}</p>`"
            ></div>
        </div>
        <!-- Right content -->
        <div class="flex-1">
            <GroupCard
                :name="$t('patients.prescription.howItWorks.title')"
                :items="[
                    'patients.prescription.howItWorks.list.logIn',
                    'patients.prescription.howItWorks.list.bookAppointment',
                    'patients.prescription.howItWorks.list.getRecipe',
                ]"
                :itemBackgroundColor="'bg-violet-900'"
                :bgColor="'bg-violet-900'"
                :titleColor="'text-white'"
                :textColor="'text-white'"
                :link="href"
                :price="299"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import GroupCard from "~/components/GroupCard.vue";
import { useLanguagesStore } from "~/stores/languages";
const languageStore = useLanguagesStore();

// Make href reactive
const href = computed(
    () =>
        (languageStore.getSelectedLanguage === "no"
            ? "https://booking.pridok.no/appointment/e6af7ac5-8fcb-48d7-9f39-fb1ee283a522/KAR/df5ef6a7-f1f4-4003-9433-a92233d6c067"
            : "/contact") as string,
);
</script>

<style scoped></style>
